import AuthModel from './AuthModel'
import axios from 'axios'
import Geoserver from './Geoserver'
import ol from 'openlayers'
import config from 'react-observable-store'
import moment from 'moment'
import FileSaver from 'file-saver'

const dateFormat = 'YYYY/MM/DD'
const format = 'HH:mm'

/**
 * Issues model
 *
 * Responsible to comunicate with remote server
 * @type {String}
 */
const IssuesModel = {

    olMap: false,

    /**
     * Server endpoint
     * @type {String}
     */
     endpoint: () => {
         return config.get('globals').server.endpoint + '/issues'
     },

    /**
     * Get HTTP options
     * @return {object}
     */
    getOptions: () => {
        return {
            headers: {
                'X-Authorization': AuthModel.getAuthToken()
            }
        }
    },

    /**
     * Download file
     * @param  {String} filename The file name
     * @param  {[type]} url      The download url
     * @param  {[type]} type     mime type
     * @return {null}            Async return
     */
    download: (filename, url, type, cb) => {
        var reqOptions = {
            responseType: 'arraybuffer',
            headers: {
                'X-Authorization': AuthModel.getAuthToken()
            }
        }
        axios.get(url, reqOptions)
        .then(res => {
            if (typeof cb === 'function') cb();
            if (res.status === 200) {
                var blob = new Blob([res.data], {type: type})
                FileSaver.saveAs(blob, filename)
            } else {
                console.log('error downloading status: ', res.status)
            }
        })
        .catch((error) => {
            console.log(error)
        })
    },

    /**
     * Dispense a new record
     * @return {object} The new record as object
     */
    dispense: () => {
        return {
            id: '',
            step: 0,
            mapZoom: 6,
            mapCenter: [-890098.6486544819, 4802796.404035872],
            issue_type: '',
            fonte_tipo: 'Sim enquanto autor',
            fonte_texto: '',
            status: '',
            attachments: [],
            address: '',
            dicofre: '000000',
            freguesia: '',
            concelho: '',
            distrito: '',
            arh_cod: '',
            arh: '',
            praia: '',
            lon: null,
            lat: null,
            title: '',
            entity: '',
            user: '',
            email: '',
            issue_date: moment().format('YYYY')+'/01/01',
            issue_time: '00:00',
            issue_reg_date: '',
            issue_reg_time: '',
            data_ocorrencia_tipo: 0,
            issue_reg_local_date: moment().format('YYYY')+'/01/01',
            issue_reg_local_time: '00:00',
            submitdate: null,
            issue_detection: 1,
            type_a: false,
            type_ai: false,
            type_ai_meters: 0,
            type_aii: false,
            type_b: false,
            type_bi: false,
            type_bi_meters: 0,
            type_bii: false,
            type_bii_meters: 0,
            type_c: false,
            type_d: false,
            type_d_meters: 0,
            cons_a: '1',
            cons_aiii_qtt: 1,
            cons_bi: true,
            cons_bii: false,
            cons_bii1: false,
            cons_bii2: false,
            cons_bii3: false,
            cons_biii: false,
            cons_biv: false,
            cons_bv: false,
            miti: '1',
            miti_c_i: null,
            miti_c_ii: null,
            miti_c_iii: null,
            miti_c_iv: null,
            miti_c_v: null,
            obs: '',
            attach_a: false,
            attach_b: false,
            attach_c: false,
            attach_ci: false,
            attach_cii: false,
            attach_ciii: false,
            attach_civ: false,
            attach_cv: false,
            attach_d: false,
            attach_d_name: '',
            privacy_accepted: false,
            programa_id: null
        }
    },

    /**
     * Dispense a new search form
     * @return {object} The new record as object
     */
    dispenseSearchForm: () => {
        return {
            status: '',
            dicofre: '000000',
            freguesia: '',
            concelho: '',
            distrito: '',
            arh_cod: '',
            praia: '',
            entity: '',
            user: '',
            email: '',
            data_ocorrencia_tipo: 0,
            /*
            issue_date_start: moment().format('YYYY')+'/01/01',
            issue_date_end: moment().format('YYYY')+'/12/31',
            issue_reg_start: moment().format('YYYY')+'/01/01',
            issue_reg_end: moment().format('YYYY')+'/12/31',
            issue_reg_date: moment().format('YYYY')+'/01/01',
            issue_reg_local_start: moment().format('YYYY')+'/01/01',
            issue_reg_local_end: moment().format('YYYY')+'/12/31',
            */
            issue_date_start: '',
            issue_date_end: '',
            issue_reg_start: '',
            issue_reg_end: '',
            issue_reg_date: '',
            issue_reg_local_start: '',
            issue_reg_local_end: '',
            issue_detection: 0,
            tipo_a: false,
            tipo_b: false,
            tipo_c: false,
            tipo_d: false,
            cons_a: 0,
            cons_bi: false,
            cons_bii: false,
            cons_biii: false,
            cons_biv: false,
            cons_bv: false,
            sort_column: '',
            sort_order: ''
        }
    },

    /**
     * Get administrative limits by lon lat
     * @param  {Number}   lon Longitude
     * @param  {Number}   lat Latitude
     * @param  {Function} cb  Async return
     * @return {[type]}       [description]
     */
    getAdmLimitsByLonLat: (lon, lat, cb) => {
        var layer = 'wkt:get_caop_by_point'
        Geoserver.wfsGetFeaturesByLayerLonLat(layer, lon, lat, (caop) => {
            cb(caop)
        })
    },

    /**
     * Get administrative limits by lon lat
     * @param  {Number}   lon Longitude
     * @param  {Number}   lat Latitude
     * @param  {Function} cb  Async return
     * @return {[type]}       [description]
     */
    getLocationByLonLat: (lon, lat, cb) => {
        axios.get(IssuesModel.endpoint() + '/location/' + lon + '/' + lat, IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb(false)
        })
        .catch((error) => {
            cb({})
        })
    },

    /**
     * Find all records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findAll: (cb) => {
        return axios.get(IssuesModel.endpoint() + '/all', IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Find user own records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findOwn: (cb) => {
        if (!AuthModel.isAuthenticated()) return cb([])
        return axios.get(IssuesModel.endpoint(), IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Search for records
     * @param   {Object}    filter  The filter to use
     * @param   {Function}  cb      Async return
     * @return  {[type]}            [description]
     */
    search: (filter, cb) => {
        var url = IssuesModel.endpoint() + '/search?'
        Object.keys(filter).forEach((k) => {
            url += '&' + k + '=' + filter[k]
        })
        return axios.get(url, IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Find record
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    find: (id, cb) => {
        return axios.get(IssuesModel.endpoint() + '/' + id, IssuesModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                res.data = IssuesModel.convertFormFieldNames(res.data)
                cb(res.data)
            } else cb({})
        })
        .catch((error) => {
            cb({})
        })
    },

    /**
     * Find public record
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findPublic: (id, code, cb) => {
        return axios.get(IssuesModel.endpoint() + '/public/' + id + '/' + code,
            IssuesModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                res.data = IssuesModel.convertFormFieldNames(res.data)
                cb(res.data)
            } else cb({})
        })
        .catch((error) => {
            cb({})
        })
    },

    /**
     * Find record
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    rotateImage: (id, cb) => {
        return axios.get(IssuesModel.endpoint() + '/image/autorotate/' + id, IssuesModel.getOptions())
        .then(res => {
            cb(true)
        })
        .catch((error) => {
            cb(false)
        })
    },

    /**
     * Store record
     * @param  {object}   item The record to store
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    store: (item, cb) => {

        // Filter fields to store
        var endpoint = IssuesModel.endpoint(), formData = {}
        const fields = Object.keys(IssuesModel.dispense())
        for (var i = 0; i < fields.length; i++) {
            formData[fields[i]] = item[fields[i]]
        }
        if (!AuthModel.isAuthenticated()) endpoint = endpoint + '/anonymous'
        axios.post(endpoint, formData, IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb({})
        })
    },

    /**
     * Upload file to import
     * @param  {object}   item The record to store
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    upload: (item, cb) => {
        axios.post(IssuesModel.endpoint() + '/upload', item, IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb({})
        })
    },

    /**
     * Remove record
     * @param  {object}   item The record to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    remove: (item, cb) => {
        axios.delete(IssuesModel.endpoint() + '/' + item.id, IssuesModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Remove attachment
     * @param  {object}   item The record to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    removeAttach: (item, cb) => {
        axios.delete(IssuesModel.endpoint() + '/attach/' + item.id, IssuesModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Remove temporary attachment
     * @param  {object}   filename The filename to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    removeTempAttach: (item, cb) => {
        const url = IssuesModel.endpoint() + '/tempattach/'+item.user+'/'+item.type+'/'+item.name
        axios.delete(url, IssuesModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Find all praia records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    getSearchFields: (cb) => {
        return axios.get(IssuesModel.endpoint() + '/search/fields', IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb({})
        })
        .catch((error) => {
            cb({})
        })
    },

    /**
     * Find all praia records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findAllPraias: (cb) => {
        return axios.get(IssuesModel.endpoint() + '/praias', IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Get issue type options
     */
    getIssueTypeOptions: (cb) => {
        return axios.get(IssuesModel.endpoint() + '/issue_type_options', IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Get data source options
     */
    getDataSourceOptions: (cb) => {
        return axios.get(IssuesModel.endpoint() + '/data_source_options', IssuesModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Convert names from server to client
     * @param  {Object} item The issue object
     * @return {Object}      The issue object converted
     */
    convertFormFieldNames: (item) => {
        item.user = item.tecnico
        item.entity = item.entidade
        item.issue_type = item.issue_type
        item.fonte_tipo = item.fonte_tipo
        item.fonte_texto = item.fonte_texto
        item.issue_detection = item.detecao_ocorrencia
        item.issue_date = moment(item.data_ocorrencia).format(dateFormat)
        item.issue_time = moment(item.data_ocorrencia).format(format)
        item.issue_reg_date = item.data_registo
        item.issue_reg_local_date = moment(item.data_registo_local).format(dateFormat)
        item.issue_reg_local_time = moment(item.data_registo_local).format(format)
        item.submitdate = item.data_submissao
        item.address = item.localizacao
        item.dicofre = item.freguesia_cod
        item.type_a = item.tip_inst_arribas
        item.type_ai = item.tip_mmv
        item.type_ai_meters = item.tip_mmv_alcance_deposito
        item.type_aii = item.tip_fenda_visivel
        item.type_b = item.tip_erosao_arribas
        item.type_bi = item.tip_escarpamento_duna
        item.type_bi_meters = item.tip_altura_maxima_escarpa
        item.type_bii = item.tip_rebaixamento_praia
        item.type_bii_meters = item.tip_reb_praia_altura_max
        item.type_c = item.tip_dano_obra
        item.type_d = item.galgamento_costeiro
        item.type_d_meters = item.tip_galg_cost_alcance_max
        item.miti = String(item.tipo_medida_mitigacao_id)
        item.miti_c_i = item.mitig_sinalizacao !== null ? (item.mitig_sinalizacao === 0 ? 'i' : 'a') : null
        item.miti_c_ii = item.mitig_delimitacao !== null ? (item.mitig_delimitacao === 0 ? 'i' : 'a') : null
        item.miti_c_iii = item.mitig_saneamento !== null ? (item.mitig_saneamento === 0 ? 'i' : 'a') : null
        item.miti_c_iv = item.mitig_reabilitacao !== null ? (item.mitig_reabilitacao === 0 ? 'i' : 'a') : null
        item.miti_c_v = item.mitig_reforco !== null ? (item.mitig_reforco === 0 ? 'i' : 'a') : null
        item.cons_a = String(item.tipo_consequencia_pessoas_risco_id)
        item.cons_aiii_qtt = item.pessoas_risco_quantidade
        item.cons_bi = item.conseq_danos_infraestruturas
        item.cons_bii = item.conseq_danos_protecao_costeira
        item.cons_bii1 = item.conseq_danos_protec_estrutura_aderente
        item.cons_bii2 = item.conseq_danos_protecao_esporao
        item.cons_bii3 = item.conseq_danos_protecao_obra
        item.cons_biii = item.conseq_danos_areas_construidas
        item.cons_biv = item.conseq_danos_edificacoes
        item.cons_bv = item.conseq_danos_outras
        item.attach_ci = item.lev_topo_area
        item.attach_cii = item.lev_topo_perfil
        item.attach_ciii = item.lev_topo_base
        item.attach_civ = item.lev_topo_obra
        item.attach_cv = item.lev_topo_mmv
        item.obs = item.observacoes
        item.mapCenter = [item.lon, item.lat]
        item.mapZoom = 14
        return item
    },

    /**
     * Get default marker style
     * @return {Object} [description]
     */
    getMarkerStyle: () => {
        var style = new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: '/assets/images/caution_red_blur.png'
            })
        })
        return style
    },

    /**
     * Get selected style
     * @return {[type]} [description]
     */
    getMarkerSelectedStyle: () => {
        var style = new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: '/assets/images/caution_red_selected.png'
            })
        })
        return style
    },

    /**
     * Get selected style
     * @return {[type]} [description]
     */
    getProgramMarkerSelectedStyle: () => {
        var style = new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: '/assets/images/letter_p_blue.png'
            })
        })
        return style
    },

    /**
     * Create real estate marker
     * @param  {String} name   The name of the marker
     * @param  {Object} coords The item coords
     * @return {Object}        The open layers feature
     */
    createMarker: (title, coords) => {
        var feature = new ol.Feature({
            geometry: new ol.geom.Point(coords),
            name: title
        })
        var style = IssuesModel.getMarkerSelectedStyle()
        feature.setStyle(style)
        return feature
    },

    /**
     * Put map marker - simple API to put a marker on map
     * @param  {String}     mapName         The map name
     * @param  {String}     layerName       The layer name
     * @param  {Array}      coords          The array [lon, lat]
     * @param  {Boolean}    [unique=false]  Should clear other markers
     * @param  {String}     [name='Marker'] The marker name identifier
     * @return {Object}                     The marker
     */
    putMarker: (coords, unique = false, name = 'Marcador') => {
        var marker, layer
        IssuesModel.olMap.getLayers().forEach((l) => {
            if (l.get('name') === 'Ocorrências') {
                layer = l
            }
        })
        if (unique && layer.getSource().getFeatures().length) {
            marker = layer.getSource().getFeatures()[0]
            marker.getGeometry().setCoordinates(coords)
        } else {
            marker = IssuesModel.createMarker(name, coords)
            layer.getSource().addFeature(marker)
        }
        return marker
    },

    /**
     * Add select and drag interactions
     * @param {String} mapName  The map name
     * @param {Function} dragCb The drag end callback
     */
    addMapSelectAndDrag: (dragCb) => {
        var select = new ol.interaction.Select()
        var translate = new ol.interaction.Translate({
           features: select.getFeatures()
        })
        IssuesModel.olMap.addInteraction(select)
        IssuesModel.olMap.addInteraction(translate)

        // On translate event
        translate.on('translateend', (a, b) => {
            var coords = {native: [0,0], lonlat: [0,0]}
            coords.native = a.coordinate
            coords.lonlat = ol.proj.transform(a.coordinate, 'EPSG:3857', 'EPSG:4326')
            dragCb(coords)
        })
        return select
    },

    /**
     * Get maximum attach upload file size
     * @return {[type]} [description]
     */
    getMaxUploadSize: () => {
        return config.get('globals').max_upload
    },

    /**
     * Generate new id
     * @return {number} The new id
     */
    generateAnonymousId: () => {
        return 'public_' + (Math.floor(Math.random() * 1000000) + 1)
    },

    /**
     * Create openlayers map from config
     * @param  {Object} conf The configuration object
     * @param  {Array} center The center coordinates
     * @param  {Number} zoom   The zoom number
     * @return {ol.Map}        [description]
     */
    createMap: (conf, center, zoom) => {
        var mapconf = Object.assign({}, conf)
        var map = new ol.Map({
            target: null,
            renderer: 'canvas',
            layers: IssuesModel.createLayers(mapconf.layers),
            view: new ol.View({
                center: center || mapconf.center,
                zoom: zoom || mapconf.zoom
            })
        })
        return map
    },

    /**
     * Create layers from config array
     * @param  {Array} conf The layers configuration array
     * @return {Array}        The openlayers layers array
     */
    createLayers: (conf) => {
        var result = []
        conf.forEach((item) => {
            result.push(IssuesModel.createLayer(item))
        })
        return result
    },

    /**
     * Creates a map layer based on configuration
     * @param  {[type]} conf [description]
     * @return {[type]}        [description]
     */
    createLayer: (conf) => {
        var layer, layerconf = Object.assign({}, conf)
        switch(conf.type) {

            case 'group':
            layerconf.layers = IssuesModel.createLayers(layerconf.layers)
            layer = new ol.layer.Group(layerconf)
            break

            case 'tile':
            layerconf.source = IssuesModel.createSource(conf.source)
            layer = new ol.layer.Tile(layerconf)
            break

            case 'vector':
            layerconf.source = IssuesModel.createSource(conf.source)
            layer = new ol.layer.Vector(layerconf)
            break

            default: ;
        }
        return layer
    },

    /**
     * Create openlayers source from config
     * @param  {Object} conf The source configuration
     * @return {[type]}      [description]
     */
    createSource: (conf) => {
        var source, sourceconf = Object.assign({}, conf)
        switch(conf.type) {

            case 'tilewms':
            sourceconf.attributions = [new ol.Attribution(Object.assign({}, conf.attributions))]
            source = new ol.source.TileWMS(sourceconf)
            break

            case 'xyz':
            sourceconf.attributions = [new ol.Attribution(Object.assign({}, conf.attributions))]
            source = new ol.source.XYZ(sourceconf)
            break

            case 'vector':
            source = new ol.source.Vector(sourceconf)
            break

            default: ;
        }
        return source
    }
}

export default IssuesModel



// WEBPACK FOOTER //
// ./src/models/IssuesModel.js